import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=d7b2d0a6&scoped=true&"
import script from "./instruction.vue?vue&type=script&lang=js&"
export * from "./instruction.vue?vue&type=script&lang=js&"
import style0 from "./instruction.vue?vue&type=style&index=0&id=d7b2d0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b2d0a6",
  null
  
)

component.options.__file = "instruction.vue"
export default component.exports